import { render, staticRenderFns } from "./EditExtrudePanel.vue?vue&type=template&id=cd1fbbca&scoped=true"
import script from "./EditExtrudePanel.vue?vue&type=script&lang=js"
export * from "./EditExtrudePanel.vue?vue&type=script&lang=js"
import style0 from "./EditExtrudePanel.vue?vue&type=style&index=0&id=cd1fbbca&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd1fbbca",
  null
  
)

export default component.exports